// React
import { memo } from 'react'

// MUI
import Box from '@mui/material/Box';

function getStyles(left, top, width, height) {
    const transform = `translate3d(${left}px, ${top}px, 0)`
    return {
        position: 'absolute',
        top:'0px',  // with no top or left, position 'absolute' doesn't seem to take effect
        width:`75%`, 
        maxWidth:`${width}px`, 
        borderRadius: '5px',
        border:'1px solid', 
        borderColor:'black',
        transform,
        WebkitTransform: transform,
        opacity: 0.5,
    }
}

export const FlowPaletteBoxPreview = memo(function FlowPaletteBoxPreview(props) {
    const { title, left, top, width, height } = props
    
    return (
        <Box
            sx={getStyles(left, top, width, height)}
            role="FlowPaletteBoxPreview"
        >
            <Box 
                sx={{
                    alignContent: 'center',
                    justifyContent: 'center'}}>
                {title}
            </Box>
        </Box>
    )
})

export default FlowPaletteBoxPreview;

